import { connect } from 'react-redux';
import Thread from '../components/Thread';
import { getContents } from '../actions/data';

const mapStateToProps = ({data}, ownProps) => {
  return {
    threadId: ownProps.match.params.id,
    threads: data.threads,
    contents: data.contents,
    error: data.getContentsError
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getContents(id) {
      dispatch(getContents(id));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Thread);
